// extracted by mini-css-extract-plugin
module.exports = {"root":"sliders_root__2jy9D","slider-wrapper":"sliders_slider-wrapper__1ZHk9","sliderWrapper":"sliders_slider-wrapper__1ZHk9","desktop":"sliders_desktop__giLuB"};